'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeMatterSuccessIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeMatterSuccessIcon">
      <svg width="84" height="87" viewBox="0 0 84 87" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.8577 12.8594C4.53208 12.8594 0.214844 17.1766 0.214844 22.5022V77.1451C0.214844 82.4705 4.53208 86.7879 9.8577 86.7879H74.1434C79.4688 86.7879 83.7863 82.4705 83.7863 77.1451V22.5022C83.7863 17.1766 79.4688 12.8594 74.1434 12.8594H9.8577Z"
          fill="#D8DCE5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5011 0C22.1639 0 24.3225 2.15862 24.3225 4.82143V20.8929C24.3225 23.5556 22.1639 25.7143 19.5011 25.7143C16.8383 25.7143 14.6797 23.5556 14.6797 20.8929V4.82143C14.6797 2.15862 16.8383 0 19.5011 0ZM42.0011 0C44.6639 0 46.8225 2.15862 46.8225 4.82143V20.8929C46.8225 23.5556 44.6639 25.7143 42.0011 25.7143C39.3383 25.7143 37.1797 23.5556 37.1797 20.8929V4.82143C37.1797 2.15862 39.3383 0 42.0011 0ZM69.3225 4.82143C69.3225 2.15862 67.1638 0 64.5011 0C61.8384 0 59.6797 2.15862 59.6797 4.82143V20.8929C59.6797 23.5556 61.8384 25.7143 64.5011 25.7143C67.1638 25.7143 69.3225 23.5556 69.3225 20.8929V4.82143Z"
          fill="#5073C3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M62.3254 40.3692C63.9956 41.8304 64.1646 44.3687 62.7034 46.0387L40.2037 71.7531C38.8197 73.3346 36.4506 73.5827 34.7692 72.3214L21.9121 62.6786C20.1368 61.3472 19.7771 58.8288 21.1085 57.0536C22.4399 55.2784 24.9583 54.9186 26.7335 56.2501L36.6098 63.6573L56.6562 40.7471C58.1174 39.0772 60.6557 38.908 62.3254 40.3692Z"
          fill="#5073C3"
        />
      </svg>
    </SvgIcon>
  )
}

LargeMatterSuccessIcon.propTypes = {
  sx: PropTypes.object
}
